const binding = { modules: {}, dataActions: {} };

    (binding.modules['widget-container'] = {
        c: () => require('partner/modules/widget-container/widget-container.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'widget-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/widget-container'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|widget-container|widget-container'] = {
                c: () => require('partner/modules/widget-container/widget-container.view.tsx'),
                cn: '__local__-__local__-widget-container'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };